import { Button, Checkbox, Label, Select, TextInput } from '@elladx/design-system';
import { RefreshCw, Search } from 'lucide-react';
export type SortOption = 'name' | 'city' | 'shipments' | 'recent';
export type ShipmentFilter = 'all' | 'shipped' | 'not_shipped';
interface AddressToolbarProps {
    allSelected: boolean;
    selectionDisabled: boolean;
    onSelectAll: (checked: boolean) => void;
    syncing: boolean;
    syncCursor: string | null;
    onSync: () => void;
    searchQuery: string;
    onSearchChange: (value: string) => void;
    shipmentFilter: ShipmentFilter;
    onShipmentFilterChange: (value: ShipmentFilter) => void;
    sortBy: SortOption;
    onSortChange: (value: SortOption) => void;
}
const FILTERS: {
    value: ShipmentFilter;
    label: string;
}[] = [
    { value: 'all', label: 'All' },
    { value: 'not_shipped', label: 'Not shipped' },
    { value: 'shipped', label: 'Recently used' },
];
function AddressToolbar({ allSelected, selectionDisabled, onSelectAll, syncing, syncCursor, onSync, searchQuery, onSearchChange, shipmentFilter, onShipmentFilterChange, sortBy, onSortChange, }: AddressToolbarProps) {
    return (<div className="card-toolbar address-toolbar">
      <div className="field-search" style={{ width: '220px' }}>
        <Search size={12} aria-hidden="true"/>
        <TextInput type="search" placeholder="Search name, company, or city" aria-label="Search saved addresses" value={searchQuery} onChange={(e) => onSearchChange(e.target.value)}/>
      </div>

      <div className="segmented" role="group" aria-label="Filter by shipment status">
        {FILTERS.map((option) => (<Button key={option.value} type="button" className={`address-filter ${shipmentFilter === option.value ? "active" : ""}`} aria-pressed={shipmentFilter === option.value} onClick={() => onShipmentFilterChange(option.value)} variant="secondary">
            {option.label}
          </Button>))}
      </div>

      <Select className="select-compact" aria-label="Sort saved addresses" value={sortBy} onChange={(e) => onSortChange(e.target.value as SortOption)}>
        <option value="name">Sort · Name</option>
        <option value="city">Sort · City</option>
        <option value="shipments">Sort · Most shipments</option>
        <option value="recent">Sort · Recently shipped</option>
      </Select>

      <Button className="address-sync" onClick={onSync} disabled={syncing} title="Import addresses from shipment history" variant="secondary" type="button" size="sm" isLoading={syncing}>
        <RefreshCw size={12}/>
        {syncing ? 'Syncing…' : syncCursor ? 'Continue sync' : 'Sync from orders'}
      </Button>
      <Label className="checkbox-label select-all-recipients">
        <Checkbox checked={allSelected} onChange={e => onSelectAll(e.target.checked)}
          aria-label="Select all visible addresses" disabled={selectionDisabled} />
        Select all recipients
      </Label>
    </div>);
}
export default AddressToolbar;
